import React from "react";
import { ArrowRightIcon } from "lucide-react";
export const CHECKOUT_URL = "https://arlb-en.impultienda.ar/checkout/";
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
};
export function CtaButton({
  label,
  sub,
  id
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-33" data-mp="ckslq8ri4uc3">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-brand-cta px-5 py-5 text-center text-[16px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#24481a,0_18px_32px_-12px_rgba(47,74,42,0.6)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-brand-ctaDark active:translate-y-[4px] active:shadow-[0_2px_0_0_#24481a,0_8px_16px_-10px_rgba(47,74,42,0.6)] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-sage/50 sm:text-lg md:py-6 md:text-xl" data-id="element-34" data-mp="cj7rkk93nder">
        <span className="[text-wrap:balance]" data-id="element-35" data-mp="157df1erjfgia">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-36" data-mp="35y7jegm11101" />
      </a>
      {sub && <p className="mt-4 max-w-md text-center text-sm leading-relaxed text-ink/70 md:text-[15px]" data-id="element-37" data-mp="3ewsw3v4thlsw">
          {sub}
        </p>}
    </div>;
}